// Simplified status mapping — 6 backend statuses → 2 display statuses
export const SIMPLIFIED_STATUS = {
  OPEN: 'Open',
  ESCALATED: 'Open',
  WAITING_ON_CUSTOMER: 'Open',
  WAITING_ON_INTERNAL: 'Open',
  IN_PROGRESS: 'Open',
  RESOLVED: 'Closed',
  CLOSED: 'Closed',
};

export const CLOSED_STATUSES = ['RESOLVED', 'CLOSED'];

export const ROLE_LABELS = { PARENT: 'Parent', TEACHER: 'Teacher' };

// RESOLVED excluded: a user reply auto-reopens a resolved ticket server-side.
export const LOCKED_STATUSES = ['CLOSED'];
